import * as React from "react";
import Shell from "../layout/shell";
import { isImageFeatureBlock, isCardLayout, isPeopleLayout } from "../helpers/prismicHelpers";
import { ImageFeatureBlock } from "../components/imageFeatureBlock";
import { Cards } from "../components/cards";
import { People } from "../components/people";

var AboutUs = function AboutUs(_ref) {
  var data = _ref.data;
  var content = data.prismic.allAbout_uss.edges[0].node;
  return /*#__PURE__*/React.createElement(Shell, null, content.body.map(function (slice) {
    if (isImageFeatureBlock(slice)) {
      return /*#__PURE__*/React.createElement(ImageFeatureBlock, {
        data: slice
      });
    }

    if (isCardLayout(slice)) {
      return /*#__PURE__*/React.createElement(Cards, {
        data: slice
      });
    }

    if (isPeopleLayout(slice)) {
      return /*#__PURE__*/React.createElement(People, {
        data: slice
      });
    }
  }));
};

export default AboutUs;
export var query = "2940118192";